import { render, staticRenderFns } from "./WPClusterList.vue?vue&type=template&id=8ff2214a&scoped=true&"
import script from "./WPClusterList.vue?vue&type=script&lang=js&"
export * from "./WPClusterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff2214a",
  null
  
)

export default component.exports